export type SeriesPoints = {
  gameWin: number;
  roundBonus: number;
  seriesWinRequired?: boolean;
};

export function calculateSeriesPoints(wins: number, wonSeries: boolean, points: SeriesPoints): number {
  if (points.seriesWinRequired && !wonSeries) return 0;
  return wins * points.gameWin + (wonSeries ? points.roundBonus : 0);
}
